import { HttpParams } from '@angular/common/http';

export class HttParamsHelper {

  public static getHttpParams(): HttpParams {
    return new HttpParams();
  }

}
